class ViewInRoomTrigger extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (e) => {
      const trigger = e.target.closest("[data-trigger]");

      if (!trigger) return;

      const template = this.querySelector("template");

      const currentVariant = this.getAttribute("current-variant");

      template.content
        .querySelector("view-in-room")
        .setAttribute("current-variant", currentVariant);

      template.content
        .querySelector("product-form-selectors")
        .setAttribute("current-variant", currentVariant);

      trigger.dispatchEvent(
        new CustomEvent("markup-modal:open", {
          bubbles: true,
          detail: {
            nodes: [...template.content.children],
            target: "view-in-room-modal",
          },
        }),
      );
    });

    this.handleVariantChange = (e) => {
      this.setAttribute("current-variant", e.detail?.variant?.id || "");
    };
  }

  connectedCallback() {
    document.addEventListener("variant:changed", this.handleVariantChange);
  }

  disconnectedCallback() {
    document.removeEventListener("variant:changed", this.handleVariantChange);
  }
}

if (!customElements.get("view-in-room-trigger")) {
  customElements.define("view-in-room-trigger", ViewInRoomTrigger);
}
